<template>
    <div>

        <form method="post" action="#" v-on:submit.prevent="submit" class="mb-3">

            <input type="hidden" name="_token" :value="$csrf_token">

            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="card-customer-name">Vor- und Nachname</label>
                        <input type="text" class="form-control" required v-model="customer.name" id="card-customer-name" placeholder="John Smith">
                    </div>
                </div>

                <div class="col-12 col-md-6">
                    <div class="form-group">
                        <label for="card-customer-email">E-Mail-Adresse</label>
                        <input type="email" class="form-control" required v-model="customer.email" id="card-customer-email" placeholder="john.smith@beispiel.de">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="card-element">
                            Kreditkartendaten
                        </label>
                        <div id="card-element" class="mb-3">
                            <!-- A Stripe Element will be inserted here. -->
                        </div>
                    </div>
                </div>

                <div class="col-12">
                    <button type="submit" class="btn btn-outline-primary" v-if="submitActive">
                        Neue Kreditkarte hinterlegen
                    </button>

                    <button type="button" class="btn btn-outline-primary" disabled v-else>
                        Neue Kreditkarte hinterlegen
                    </button>
                </div>
            </div>

        </form>

        <!-- Used to display form errors. -->
        <div id="error-message mb-3" role="alert"></div>

    </div>
</template>

<script>
export default {
    name: "AddCreditCard",

    props: {
        clientSecret: {
            type: String,
            required: true
        },
        stripe: {
            type: Object,
            required: true
        },
        givenCustomer: {
            type: Object,
            required: true
        },
        submitActive: {
            type: Boolean,
            required: false,
            default: true
        }
    },

    data() {
        return {
            stripeElements: null,
            customer: {
                name: null,
                email: null
            },
            element: {
                form: null,
                options: {
                    style: {
                        base: {
                            color: '#32325d',
                            fontSize: '16px',
                            '::placeholder': {
                                color: '#aab7c4'
                            },
                            ':-webkit-autofill': {
                                color: '#32325d',
                            },
                        },
                        invalid: {
                            color: '#fa755a',
                            iconColor: '#fa755a',
                            ':-webkit-autofill': {
                                color: '#fa755a',
                            },
                        },
                    },
                    supportedCountries: ['SEPA'],
                    // Elements can use a placeholder as an example IBAN that reflects
                    // the IBAN format of your customer's country. If you know your
                    // customer's country, we recommend passing it to the Element as the
                    // placeholderCountry.
                    placeholderCountry: 'DE',
                }
            }
        }
    },

    methods: {
        createForm() {
            this.stripeElements = this.stripe.elements ()
            this.element.form = this.stripeElements.create('card', this.element.options)
            this.element.form.mount('#card-element')
        },
        async submit(){
            const result = await this.stripe.confirmCardSetup(
                this.clientSecret,
                {
                    payment_method: {
                        card: this.element.form,
                        billing_details: {
                            name: this.customer.name,
                            email: this.customer.email
                        }
                    }
                }
            )

            if (result.error) {
                this.$notify.error({
                    title: "Fehler",
                    text: result.error.message
                })
            } else {
                this.$notify.success("Neue Kreditkarte wurde hinterlegt")
                this.$emit("new-payment-method-created", result)
            }
        }
    },

    mounted () {
        this.createForm()
        this.customer.name = this.givenCustomer.first_name + " " + this.givenCustomer.last_name
        this.customer.email = this.givenCustomer.email
    }
}
</script>

<style scoped>

</style>
